import { render, staticRenderFns } from "./MessageManagement_Component.vue?vue&type=template&id=365bc992&scoped=true&"
import script from "./MessageManagement_Component.vue?vue&type=script&lang=js&"
export * from "./MessageManagement_Component.vue?vue&type=script&lang=js&"
import style0 from "./MessageManagement_Component.vue?vue&type=style&index=0&id=365bc992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365bc992",
  null
  
)

export default component.exports